import ReactDOM from "react-dom"
import { CircleMenu, CircleMenuItem } from "react-circular-menu"
import { useNavigate } from "react-router-dom"
import GroupIcon from "@mui/icons-material/Group"
import StoreIcon from "@mui/icons-material/Store"
import PaidIcon from "@mui/icons-material/Paid"
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot"

export default function FloatingCircleMenu({ open, setOpen, setOpensFalse }) {
  const navigate = useNavigate()

  if (!open) return null // Only render when open
  const handleClickCredit = () => {
    setOpensFalse()
    navigate("/buycredit")
  }
  const handleClickMarketplace = () => {
    navigate("/marketplace")
  }
  const handleClickGroups = () => {
    setOpensFalse()
    navigate("/groups")
  }
  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 180, // adjust for navbar
        right: 20,
        zIndex: 2000,
      }}
    >
      <CircleMenu
        startAngle={-90}
        rotationAngle={360}
        itemSize={2}
        radius={5}
        rotationAngleInclusive={false}
        onDoubleClick={() => setOpen(false)}
        menuToggleElement={
          <div
            style={{
              background: "#1976d2",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #9c27b0",
              cursor: "pointer",
            }}
          >
            <ScatterPlotIcon sx={{ color: "text.primary", fontSize: 24 }} />
          </div>
        }
      >
        <CircleMenuItem
          onClick={handleClickGroups}
          tooltip='Groups'
          style={{ background: "#1976d2", color: "text.primary" }}
        >
          <GroupIcon size={24} />
        </CircleMenuItem>
        <CircleMenuItem style={{ background: "#d32f2f", color: "text.primary" }}></CircleMenuItem>
        <CircleMenuItem
          onClick={handleClickCredit}
          tooltip='Buy Credit'
          style={{ background: "#388e3c", color: "text.primary" }}
        >
          <PaidIcon size={24} />
        </CircleMenuItem>
        <CircleMenuItem
          onClick={handleClickMarketplace}
          tooltip='Marketplace'
          style={{ background: "#f57c00", color: "text.primary" }}
        >
          <StoreIcon size={24} />
        </CircleMenuItem>
      </CircleMenu>
    </div>,
    document.body
  )
}
